<template>
  <img
    v-if="full"
    :src="iconUrl"
    class="bank-icon"
    :data-bank="props.bankName"
  />

  <figure v-else>
    <img
      v-tooltip.bottom="bankDisplayName"
      height="32"
      :src="iconUrl"
      class="bank-icon"
      :data-bank="props.bankName"
    />
  </figure>
</template>

<script setup lang="ts">
import { BankName } from '@/shared';
import { getBankIconUrl } from '@/shared/lib/bank-icon';
import { computed } from 'vue';

const props = defineProps<{
  bankName: BankName;
  bankDisplayName?: string;
  full?: boolean;
}>();

const iconUrl = computed(() => getBankIconUrl(props.bankName, props.full));
</script>

<style scoped>
figure {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgb(255, 255, 255);
  animation: initial;
  position: relative;
  overflow: hidden;
  border: none;
  margin: 0px;
}

img.bank-icon {
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto;
}

/* У ATB исходный SVG визуально смещён во viewBox, компенсируем сдвиг */
img.bank-icon[data-bank='atbbank'] {
  transform: translateY(-4px);
}
</style>
